module.exports = __webpack_public_path__ + "img/Azerbaijan.19c40adc.svg";